import './LoadingIndicator.scss';

import { Spin } from 'antd';
import React from 'react';

interface Props {
  background?: boolean;
}

const LoadingIndicator = (props: Props) => (
  <div className={`LoadingIndicator ${props.background ? 'white-bg' : ''}`}>
    <Spin />
  </div>
);

export default LoadingIndicator;
